import * as React from "react";
import UserForm from "./UserForm";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SectionView from "../../layout/section/SectionView";
import Row from "../../layout/Row";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../layout/Col";
import SelectRolesFormGroup from "./roles/SelectRolesFormGroup";
import AddressFormGroup from "../../address/form/component/AddressFormGroup";
import PhoneFormGroup from "../../lead/form/component/PhoneFormGroup";
import BrandFormGroup from "./BrandFormGroup";
import TextAreaFormGroup from "../../ui/form/TextAreaFormGroup";
import {none, option, Option} from "ts-option";
import SingleFileDropDown from "../../file/SingleFileDropDown";
import Attachment from "../../../model/attachment/Attachment";
import PartnerBrandFormGroup from "../../lead/form/PartnerBrandFormGroup";
import {FormField} from "../../../validation/FormField";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";
import {UserRole} from "../../../model/user/UserRole";
import FormValidators from "../../../validation/FormValidators";
import ConfirmChangePartnerBrandModal from "../../lead/v4/partnerBrand/confirmationModal/ConfirmChangePartnerBrandModal";
import {RootState} from "../../../store/reducer/root/RootState";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import User from "../../../model/user/User";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ReduxProps {
	/**
	 * Indicates if the user has the option of disabling user
	 */
	canDisableUser: boolean
}

interface ComponentProps {
	/**
	 * Username field disabled flag
	 */
	usernameDisabled?: boolean
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
	/**
	 * Edit mode
	 */
	editMode?: boolean

	user?: User
}

interface State {
	/**
	 * If defined, partner brand change confirmation modal is displayed.
	 */
	partnerBrandIdToSet: Option<string>;
}

type Props = ComponentProps & FormBodyProps<UserForm> & ReduxProps;

class UserFormBody extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {partnerBrandIdToSet: none};
	}

	render() {
		const attachment = this.props.form.photoId.getOptionalValue().map(id => new Attachment(id, "", none, none, none));
		const brandFieldValue = this.props.form.brandId.getValue();
		return (
			<SectionView>
				<div className={"c-create-user"}>
					<Row>
						<Col xl={4} md={4}>
							<InputFormGroup label="First name"
											placeholder="Enter first name"
											field={this.props.form.firstName}
											onChange={this.props.onFieldChange}
											focus={this.props.form.hasFocus(this.props.form.firstName)}/>
						</Col>
						<Col xl={4} md={4}>
							<InputFormGroup label="Last name"
											placeholder="Enter last name"
											field={this.props.form.lastName}
											onChange={this.props.onFieldChange}/>
						</Col>
						<Col xl={4} md={4}>
							<InputFormGroup label="Email"
											placeholder="Enter user email"
											field={this.props.form.username}
											onChange={this.props.onFieldChange}
											trimRight={true}
											disabled={this.props.usernameDisabled}/>
						</Col>
					</Row>
					<Row>
						<Col xl={4} md={4}>
							<SelectRolesFormGroup field={this.props.form.roles}
												  placeholder={"Roles"}
												  onChange={this.onRoleChange}
												  label={"Roles"}/>
						</Col>
						<Col xl={4} md={4}>
							<AddressFormGroup field={this.props.form.address}
											  onChange={this.props.onFieldChange}
											  label={"User address"}
											  form={this.props.form}/>
						</Col>
						<Col xl={4} md={4}>
							<PhoneFormGroup label="Mobile number:"
											placeholder="Enter mobile number"
											field={this.props.form.mobileNumber}
											onChange={this.props.onFieldChange}
											multi={true}
											limit={1}/>
						</Col>
					</Row>
					<Row>
						<Col xl={4} md={4}>
							<InputFormGroup label="Profile URL"
											placeholder="Enter user's profile URL"
											field={this.props.form.profileUrl}
											onChange={this.props.onFieldChange}/>
						</Col>
						<Col xl={4} md={4}>
							<BrandFormGroup label="Brand"
											placeholder="Select brand"
											field={this.props.form.brandId}
											onChange={this.onBrandChange}/>
						</Col>
						<Col xl={4} md={4}>
							<PartnerBrandFormGroup label="Partner Brand"
												   placeholder="Select partner brand"
												   field={this.props.form.partnerBrandId}
												   onChange={this.onPartnerBrandChange}
												   brandId={brandFieldValue}
												   disabled={brandFieldValue.isEmpty}/>
						</Col>
						<Col xl={4} md={4}>
							<InputFormGroup label="Gas Safe Licence Card Number"
											placeholder="Enter licence number"
											field={this.props.form.licenceNumber}
											onChange={this.props.onFieldChange}/>
						</Col>
					</Row>
					<Row>
						<Col xl={8} md={8}>
							<TextAreaFormGroup label="Bio"
											   placeholder="Enter user's bio"
											   field={this.props.form.bioText}
											   onChange={this.props.onFieldChange}
											   rows={9}/>
						</Col>
						<Col xl={4} md={4}>
							<div className={"c-create-user_dropdown-label"}>Image</div>
							<div className={"c-create-user_dropdown-wrapper"}>
								<SingleFileDropDown attachment={attachment}
													onDropFile={this.props.onAddFile}
													onRemove={this.props.onRemoveFile}/>
							</div>
						</Col>
					</Row>
					{this.props.editMode && <Row>
						{this.props.canDisableUser &&
						<Col xl={2} md={2}>
							<CheckboxFormGroup field={this.props.form.disabled}
											   onChange={this.props.onFieldChange}
											   label={"Disabled"}
											   style={{marginTop: "10px"}}/>
						</Col>}
						{this.props.user && !this.props.user.xeroUser && this.props.user.data.mobileNumber.isDefined &&
						<Col xl={4} md={4}>
							<ButtonPrimary label={"Send SMS password re-set"}
										   onClick={this.resetPasswordThroughSms}/>
						</Col>}
					</Row>}
					{this.state.partnerBrandIdToSet.map(newPbId =>
						<ConfirmChangePartnerBrandModal hasConfirmationCheckbox={true}
														onClose={() => this.setState({partnerBrandIdToSet: none})}
														onConfirm={() => this.onConfirmPartnerBrandChange(newPbId)}/>
					).orNull}
				</div>
			</SectionView>
		);
	}

	onBrandChange = (brandField: FormField<any>) => {
		this.props.onFieldsChange([brandField, this.props.form.partnerBrandId.updateValue(none)]);
	};

	onPartnerBrandChange = (partnerBrandField: FormField<any>) => {
		const newValue = partnerBrandField.getOptionalValue();
		newValue
			.map(v => this.setState({partnerBrandIdToSet: option(v)}))
			.getOrElse(() => this.props.onFieldsChange([this.props.form.partnerBrandId.updateValue(none)]));
	};

	onConfirmPartnerBrandChange = (partnerBrandId: string) => {
		this.setState({partnerBrandIdToSet: none});
		this.props.onFieldsChange([this.props.form.partnerBrandId.updateValue(option(partnerBrandId))]);
	};

	onRoleChange = (roleField: FormField<string[]>) => {
		const isPBrandRequired = roleField.getOptionalValue().getOrElse([]).some(
			r => r === UserRole.ThirdPartyEngineer || r === UserRole.PartnerTechnician);
		let partnerBrandField: FormField<string>;
		let brandField: FormField<string>;
		if (isPBrandRequired) {
			partnerBrandField =
				this.props.form.partnerBrandId.setRules([FormValidators.nonEmptyString("Partner brand is required")]);
			brandField = this.props.form.brandId.setRules([FormValidators.nonEmptyString("Brand is required")]);
		}
		else {
			partnerBrandField = this.props.form.partnerBrandId.setRules([]);
			brandField = this.props.form.brandId.setRules([]);
		}
		this.props.onFieldsChange([roleField, partnerBrandField, brandField]);
	}

	resetPasswordThroughSms = () => {
		api.instance.userApi.requestResetPasswordThroughSms(this.props.user.id)
			.then(() => Toast.success("Reset password SMS to user was send", "Send reset password SMS"))
			.catch(e => notifyBugsnagAndShowToast(e, "Send reset password SMS"))
	}
}

function mapStateToProps(state: RootState) {
	return {
		canDisableUser: state.user.user.map(user =>
			!user.isBusinessDevelopmentPartner() || user.isAdmin()).getOrElse(false)
	}
}

export default withRouter(connect(mapStateToProps)(UserFormBody));
